export const roundNDecimal = (value: number | string, n = 2) => {
  if (typeof value === 'undefined') {
    return value;
  }

  return value.toString().includes('.') ? Number(value).toFixed(n) : value;
};
